/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path querybuilder
 * @description Query Builder helper hook
 */
import Query from "./Query";
import QueryBuilder from "./QueryBuilder";
import isDraftFilterAllowedAtLocation from "./../attributes/drafts/disabledPages";
import { useQuery } from "react-query";
type QueryFunctionType = typeof Query;
type QueryFunctionArgument = (
  query: QueryFunctionType
) => ReturnType<QueryFunctionType>;
type QueryArgument = ReturnType<QueryFunctionType>;
type BuilderArgument = QueryFunctionArgument | QueryArgument;
const useQueryBuilder = <T>(fn: BuilderArgument) => {
  /**
   * if the "fn" argument is function call the function with the Query function as argument
   * If the "fn" argument is not function then it should be instance of QueryBuilder
   */
  const query = (
    typeof fn === "function" ? (fn(Query) as QueryBuilder) : fn
  ) as QueryBuilder;
  return useQuery<{
    data: T;
  }>(
    `${query.fullQuerySignature()}-${isDraftFilterAllowedAtLocation()}`,
    async () => ({
      data: await query
        .allowDraft(!isDraftFilterAllowedAtLocation())
        .fetchValues(),
    }),
    {
      enabled: query.elementIds.length > 0,
    }
  );
};
export default useQueryBuilder;
